import moment from "moment";
import { Base64 } from 'js-base64';
import version from './config';
import { Http,Storage,Session,TokenManager } from "vuezx";
import wx from 'weixin-js-sdk'
// 获取cookie cname => cookie key名称
global.getCookie = function(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();

    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return null;
};
// 显示头部
global.headerShow = function(path) {
  // 手机app
  if (
    navigator.userAgent.indexOf("Platform/") != -1 &&
    navigator.userAgent.indexOf("version/3.0.0") != -1
  ) {
    if (
      path == "/home" ||
      path == "/sort" ||
      path == "/find" ||
      path == "/mine" ||
      path == "/agreement"
    ) {
      return false;
    }
    return true;
  }
  return false;
};
// 设置headers
global.setHeaders = function(config) {
  let params = {
    appId:global.appId,// 设置appId(机构id)
    // orgCode:global.orgCode,// 设置orgCode(机构code)
    loginType:localStorage.getItem('loginType') //ij艾嘉 np混合平台 sys系统本身
  }
  global.clearEmptyKey(params)
  // 只添加headers
  if(global.appIdHeaders){
    for (let [key, value] of Object.entries(params)) {
      config.headers[key] = value
    }
  }
  // 不是只添加headers
  else if(!global.appIdHeaders){
    // 添加属性
    config.params = Object.assign({}, config.params, params)
  }
  return config
};

// 禁止页面滑动
global.htmlLock = function() {
  document.body.style.overflow = "hidden";
};
// 解除滑动限制
global.htmlRelease = function() {
  // 取消滑动限制
  document.body.style.overflow = ""; //出现滚动条
};
/**
 * 获取url地址参数对象
 * @return {*}
 */
global.getSearchParams = function(url='') {
  let index = url.indexOf('?');
  let search = url ? url.slice(index >-1 ? index + 1: '') : location.search.slice(1);
  if(!search) return null;
  let arr = search.split('&');
  let params = {};
  arr.forEach(item => {
      let [key, value] = item.split('=');
      params[key] = value;
  });
  return params;
}
/**
 * 批量设置url地址参数
 * @param params 地址参数名为key和参数值为value组成的对象
 */
global.setSearchParams = function(params, replace=true, link='') {
  let beforeParams = global.getSearchParams(link) || {};
  let afterParams = Object.assign({}, beforeParams, params);
  let keys = Object.keys(afterParams);
  let paramArr = keys.map(item => [item, afterParams[item]].join('='));
  let queryStr = paramArr.join('&');
  let search = queryStr ? '?' + queryStr : '';
  let url = (link ? link.split('?')[0] : (location.protocol + '//' + location.host + location.pathname)) + search;
  if(replace) history.replaceState({}, '', url);
  else return url;
}
/**
 * 根据key,value设置url地址参数值
 * @param key
 * @param value
 */
global.setSearchParamByKey = function(key, value) {
  let searchParams = global.getSearchParams() || {};
  searchParams[key] = value;
  setSearchParams(searchParams);
}
// 去掉分享出去from
global.setShareUrl = function(value) {
  if (window.location.href.includes('from=')) {
    if(value){window.location.href = BASE_PATH + value}
    else{window.location.href = BASE_PATH + location.hash}
  }
}
// 设置有参数url
global.setUrl = function(url, data, isClear,isEncodeURI) {
  // 去除对象内多余的空值key
  if (isClear) {
    global.clearEmptyKey(data);
  }
  let dataStr = ""; //数据拼接字符串
  Object.keys(data).forEach(key => {
    if(isEncodeURI){
      dataStr += key + "=" + encodeURIComponent(data[key]) + "&";
    }
    else{
      dataStr += key + "=" + data[key] + "&";
    }
  });
  if (dataStr !== "") {
    dataStr = dataStr.substr(0, dataStr.lastIndexOf("&"));
    // url有?
    if(url&&url.includes('?')){
      url = url + "&" + dataStr;
    }
    else{
      url = url + "?" + dataStr;
    }
  }
  return url;
};
// 去除对象内多余的空值key
global.clearEmptyKey = function(data) {
  Object.keys(data).forEach(key => {
    if (
      data[key] === null ||
      data[key] === "" ||
      data[key] === undefined ||
      data[key] === "undefined"
    ) {
      delete data[key];
    }
  });
  return data;
};
// 判断对象是否为空
global.ObjectEmpty = function(data) {
  return Object.keys(data).length === 0;
};
// 获取宝宝孕周信息
global.getDueInfo = function(today, startDay, dueDay, dayCount, type) {
  // 怀孕日期
  let startTime = new Date(startDay).getTime();
  // 预产期
  let endTime = new Date(dueDay).getTime();
  let todayTime;
  let overDays;
  if (type == 1) {
    // 用户选择日期
    todayTime = new Date(today).getTime();
    // 已经怀孕多少天
    overDays = Math.floor((todayTime - startTime) / (24 * 3600 * 1000));
  } else {
    // 今天
    todayTime = new Date().getTime();
    // 已经怀孕多少天
    overDays =
      dayCount - 1 - Math.floor((endTime - todayTime) / (24 * 3600 * 1000));
  }
  //不到1周则只显示天数 周则不显示天数
  let weeks =
    (overDays / 7 < 1 ? "" : Math.floor(overDays / 7) + "周") +
    (overDays / 7 < 1 || overDays % 7 == 0 ? "" : "") +
    (overDays % 7 == 0 ? "" : (overDays % 7) + "天");
  let overDaysText;
  overDays > 0 ? (overDaysText = overDays + "天") : (overDaysText = 1 + "天");
  // 距离预产期还有多少天
  let dayout = dayCount - overDays;
  let dueInfo = {
    overDays: overDays,
    overDaysText: overDaysText,
    weeks: weeks,
    dayout: dayout
  };
  return dueInfo;
};
// 星期几
global.getWeekday = function(date) {
  let weekday = [
    "星期日",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六"
  ];
  return weekday[moment(date).day()];
};
// 返回顶部
global.scrollBodyTop = function() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};
/*文件名打乱*/
global.random_string = function(len) {
  len = len || 32;
  var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  var maxPos = chars.length;
  var pwd = "";
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};
/* 获取后缀名 */
global.get_suffix = function(filename) {
  let pos = filename.lastIndexOf(".");
  let suffix = "";
  if (pos != -1) {
    suffix = filename.substring(pos);
  }
  return suffix;
};
/* 孕周天数 */
global.getPregnantTotalDays = function(week, day) {
  let weekCount = week != "" && week != 0 ? parseInt(week) : 0;
  let dayCount = day != "" && day != 0 ? parseInt(day) : 0;
  return weekCount * 7 + dayCount;
};
/* n周+m天 */
global.getWeekAndDay = function(overDays) {
  //不到1周则只显示天数 周则不显示天数
  let weeks = overDays / 7 < 1 ? 0 : Math.floor(overDays / 7);
  let day = overDays % 7 == 0 ? 0 : overDays % 7;
  let weeksStr = weeks > 0 ? `${weeks}周` : "";
  let dayStr = day > 0 ? `+${day}天` : "";
  let weeksDayInfo = {
    weeks: weeks,
    day: day,
    weeksDayStr: weeksStr + dayStr
  };
  return weeksDayInfo;
};
// 删除数组为空
global.removeEmptyArrayEle = function(arr) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] == undefined || arr[i] == null) {
      arr.splice(i, 1);
      i = i - 1;
    }
  }
  return arr;
};
// 比较
global.compare = function(val) {
  if (val || val == 0) {
    if (val > 0) {
      return `+${val}`;
    }
    if (val == 0) {
      return 0;
    }
    if (val < 0) {
      return val;
    }
  } else {
    return "--";
  }
};

global.ForDight =function(Dight, How) {
  Dight = Math.round(Dight * Math.pow(10, How)) / Math.pow(10, How);
  return Dight;
}

// 根据身份证号返回生日
global.getBirthdayByIdCard = function(idCardNo, format) {
  if(!idCardNo) return '';
  let year = idCardNo.substr(6,4),
      month = idCardNo.substr(10,2),
      day = idCardNo.substr(12,2);
  return format.replace(/yyyy/ig, year).replace(/MM/ig, month).replace(/dd/ig, day);
};
// 生成指定范围的随机整数
global.randomIntegerInRange = function(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
global.getUrlKey = function(name)
{
   return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
global.blur = function()
{
  setTimeout(function() {
     var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
     window.scrollTo(0, Math.max(scrollHeight - 1, 0));
   }, 100);
}
// 身份证号***显示（显示前4位和后4位，中间6个*代替）
global.identityCardNoFilter = function(val) {
   return val.substr(0,4) + '******' + val.substr(-4,4);
}
// 跳转地址去掉#
global.replacePath = function(val) {
   if(!(val.includes('replace'))){
    val.includes('?')?val+="&replace":val+="?replace"
   }
   val.includes('#')?val=val.replace('#',''):''
   return val
}
// 根据key获取数据
global.getDataByKey = function(data,key,value) {
  let val;
  for (let [akey, avalue] of Object.entries(data)) {
    if(avalue[key]==value){
      val = avalue
    }
  }
  return val?val:null
}

// 替换url里面${}
global.replaceUrlParams = function(data,url) {
  if (data) {
    for (let [key, value] of Object.entries(data)) {
      url = url.replace('${'+key+'}',value)
    }
    return url
  }
}

// 替换url里面appCode orgCode token 跳转艾嘉0，健康城市1带上对应参数 hosCodeType 1取zoneCode 默认取hosCode
global.appReplaceUrlParams = function(type,link,query,hosCodeType) {
  let locationSource;
  type == 1 ? locationSource = process.env.VUE_APP_health : locationSource = process.env.VUE_APP_ij120
  let data = Session.get('npLoginParams');
  let params ={
    appCode:data.npAppCode||data.ijAppCode,
    orgCode:data.npOrgCode||data.ijOrgCode,
    token:data.npToken||data.ijToken,
    // 健康城市新增
    zoneCode:type==1?Session.get('appversion').zoneCode:'',//区域代码（460200）
    zoneName:type==1?Base64.encode(Session.get('appversion').zoneName):'',//区域名称
    hosCode:type==1?(hosCodeType==1?Session.get('appversion').zoneCode:Session.get('appversion').hosCode):'',//医院
    hosName:type==1?Base64.encode(Session.get('appversion').hosName):''//医院名称
  }
  if (link.indexOf('select-hospital') > -1) {
    delete params.hosCode;
    delete params.hosName;
  }
  // 设置有参数url
  let url = global.setUrl(`${locationSource}${link}`,params,true)+(query?query:'')
  return url
}

// 获取appId
global.getAppId = function(productCode) {
  var config = version[productCode];
  return config ? config.appId : '';
}

// 获取配置
global.getConfig = function(productCode) {
  return version[productCode] ? version[productCode] : null;
}

// 获取hsyHosName
global.getHsyHosName = function(productCode) {
  return version[productCode] ? version[productCode].hsyHosName : null;
}
// 获取healthVersion配置
global.getHealthConfig = function(productCode) {
  return version[productCode] ? version[productCode].healthVersion : null;
}
// 获取healthVersion开通的角色列表
global.getHealthRoleList = function(productCode) {
  var config = global.getHealthConfig(productCode);
  if (!config) return [];
  var result = [];
  for (var i = 0, len = config.roles.length; i < len; i++) {
    if (config.roles[i].state !== 'close')
      result.push(config.roles[i]);
  }
  return result;
}
// 获取healthVersion角色信息
global.getHealthRoleConfig = function(productCode, role) {
  var roles = global.getHealthConfig(productCode).roles;
  if (!roles.length) return {};
  var result = {};
  for (var i = 0, len = roles.length; i < len; i++) {
    if (roles[i].role === role)
      return result = roles[i];
  }
  return result;
}
//ij艾嘉 np混合平台 sys系统本身 0艾嘉，1健康城市 ，2系统本身
global.getLoginType = function() {
  var loginType = localStorage.getItem('loginType')
  if(loginType=='ij'){
    return 0
  }
  if(loginType=='np'){
    return 1
  }
  if(loginType=='sys'){
    return 2;
  }
}
//跳转 ij艾嘉 np混合平台 sys系统本身 0艾嘉，1健康城市 ，2系统本身
global.getUrlType = function() {
  var urlType = Session.get('appversion').mappingType
  if(urlType=='ij'){
    return 0
  }
  if(urlType=='np'){
    return 1
  }
  if(urlType=='sys'){
    return 2;
  }
}


//H5点击热点图
global.hotclick = function(sid, hid) {
	var mta = document.createElement("script");
	mta.src = "//pingjs.qq.com/h5/hotclick.js?v2.0";
	mta.setAttribute("name", "mtah5hotclick");
	mta.setAttribute("sid", sid);
	mta.setAttribute('hid', hid);
	var s = document.getElementsByTagName("script")[0];
	if(document.getElementsByName('mtah5hotclick')[0]){
		var script = document.getElementsByName('mtah5hotclick')[0];
		s.parentNode.replaceChild(mta, script);
		return
	}
	s.parentNode.insertBefore(mta, s);
};
// 调用app方法
// androidData->传给安卓的参数
// iosData->传给ios的参数
// h5Fuc->不属于安卓和ios时调用的函数
global.callAPPFunction = function(androidData, iosData, h5Fuc, androidFuc, iosFuc) {
  switch (true) {
    case global.Browser.isAndroid&&!global.Browser.isWechat&&Session.get('appADRFlag'):
        if(androidData){
          ZoeJsBridge.postMessage(JSON.stringify(androidData))
        }
        else{
          androidFuc()
        }
      break;
    case global.Browser.isIOS&&!global.Browser.isWechat&&Session.get('appIOSFlag'):
        if(iosData){
          window.webkit.messageHandlers.ZoeJsBridge.postMessage(JSON.stringify(iosData));
        }
        else{
          iosFuc()
        }
      break;
    default:
      h5Fuc();
  }
}

/**
 * 异步加载外部js
 * @param {string} src - 外部js链接地址
 * @returns {Promise<unknown>}
 */
global.loadScriptAsync = function(src){
  let scripts = document.getElementsByTagName('script');
  let oScript = [...scripts].find(item => item.src === src); // 若页面已有引入该js链接，则移除重新添加
  if (oScript) {
    oScript.parentNode.removeChild(oScript);
  }
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.onerror = reject;
    script.onload = resolve;
    document.head.appendChild(script);
  })
}

/**
 * 微信配置
 * @param {Array<string>} jsApiList - 必填，需要使用的JS接口列表
 * @param {Array<string>} openTagList - 非必填，需要使用的开放标签列表
 * @returns {Promise<boolean>} - 配置是否成功
 */
global.weiXinConfig = function(jsApiList, openTagList= []) {
  console.log('jsApiList:', jsApiList);
  console.log('openTagList:', openTagList);
  wx.config({
    debug: true,
    /*access_token: "58_ATw8mVONd_CsCLLc0ur9rCQ-tm_daKie0EKoH3D5tA7XPw875gny4T71zIFAZTjSlpBtQ_aY12DUl3euvtV64HTrXtyI5QF7kJpvzDpRCKkyM4Q6uYayl5wDT6h5O1QJ61pjjY8pn2j0bIVsNHGbAIAUON",
    jsapi_ticket: "LIKLckvwlJT9cWIhEQTwfACYq0Q3ru64QV5ZqOR64ee1lxPUntnUmPhQ9_MIMjuhkI0e0LAHrfwm40bniEA-xQ",*/
    nonceStr: "3cu7hb8tovl",
    timestamp: "1657355465",
    signature: "45d4bca3112a89820493eee207bfa9d9c629e55c",
    appId: global.WECHAT_APP_ID,
    jsApiList: jsApiList, // 必填，需要使用的JS接口列表
    openTagList: openTagList,
    success() {
    },
    fail() {
    },
  })
}
export default {
	  versionUlr:{
      ijBook:'reservation/DeptList',//艾嘉预约挂号
      npBook:'medical/appoint/yygh',//健康城市预约挂号
      onlineClassBig:'online-class/online-class-index',//线上课堂大图入口
      onlineClass:'health-class/health-class-index',//线上课堂
      liveBroadcast: 'health-class/live-studio',//直播(微信)
      ijCardAdd: 'medicalCard/cardAdd',//艾嘉卡列表
      npCardAdd: 'medical/medical-card-manage/medical-card-list',//健康城市卡列表
      npCardAddZone: 'medical/appoint/select-hospital?entryName=medicalCardList',//健康城市卡列表
      ijMoreDoctorYunChan: 'reservation/docList.html?deptCode=产科&deptId=产科&deptName=产科&isArmyMan=0&MonthIdCardNo=undefined',//产科 科室门诊详情 知名专家更多医生跳转
      ijMoreDoctorErKe: 'reservation/docList.html?deptCode=儿科&deptId=儿科&deptName=儿科&isArmyMan=0&MonthIdCardNo=undefined',//儿科 科室门诊详情 知名专家更多医生跳转
      pregnantClassIndex: 'maternity/pregnant/pregnant-class-index',//听课签到
    },
    appIOSFlag() {
      return Session.get('appIOSFlag') //IOS
    },
    appADRFlag() {
      return Session.get('appADRFlag') // 安卓
    },
    entranceFlag() {
      return Session.get('entranceFlag') //1 IOS 、 2 安卓 、3 微信
    },
    // url加上登录参数
    goRouteParamsLink(link,query) {
      let params,data;
      data = Session.get('npLoginParams')
      //登录类型
      let loginType = global.getLoginType()
      // 0艾嘉
      if (loginType == 0) {
        params ={
          verifyToken:data.npToken||data.ijToken,
          orgCode:data.npOrgCode||data.ijOrgCode,
          appCode:data.npAppCode||data.ijAppCode,
          appId:global.appId,
          loginType:localStorage.getItem('loginType'),
          needAppId:0,
          version:'1.0',
        }
        if(!global.appId){
          delete params.appId
          delete params.needAppId
        }
      }
      // 1健康城市
      if (loginType == 1) {
        params ={
          npVerifyToken:data.npToken||data.ijToken,
          npOrgCode:data.npOrgCode||data.ijOrgCode,
          npAppCode:data.npAppCode||data.ijAppCode,
          appId:global.appId,
          loginType:localStorage.getItem('loginType'),
          needAppId:0,
          version:'1.0',
        }
        if(!global.appId){
          delete params.appId
          delete params.needAppId
        }
      }
      // 2系统本身
      if (loginType == 2) {
        params ={
          appId:global.appId,
          loginType:localStorage.getItem('loginType'),
        }
        if(!global.appId){
          delete params.appId
        }
      }
      // 设置有参数url
      let url = global.setUrl(link,params,true)+(query?query:'')
      return url
    },
    // 跳转替换url里面${}
    goReplaceLink(data, link) {
      let url = global.replaceUrlParams(data, link)
      location.assign(url)
    },
    // 跳转第三方链接艾嘉或者健康城市0艾嘉，1健康城市
    goOtherLink(type, link, query, hosCodeType) {
      let url = global.appReplaceUrlParams(type, link, query, hosCodeType)
      location.assign(url)
    },
    // 跳转区别0艾嘉和1健康城市
/*    let params = {
      ijData:{
        query:`&returnUrl=${returnUrl}`
      },
      npData:{
        query:`&returnUrl=${returnUrl}`
      }
    }
     // 跳转区别艾嘉和健康城市
     this.common.goIjNpLink(2,params)
    */
    goIjNpLink(type, data) {
      //跳转类型
      let urlType = global.getUrlType()
      let link,query,hosCodeType;
      // 预约挂号
      if(type==1){
        // 0艾嘉
        if(urlType==0){
          link = this.versionUlr.ijBook
        }
        // 1健康城市
        if(urlType==1){
          link = this.versionUlr.npBook
        }
      }
      // 健康卡列表
      if(type==2){
        // 0艾嘉
        if(urlType==0){
          link = this.versionUlr.ijCardAdd
          query = data.ijData.query
        }
        // 1健康城市
        if(urlType==1){
          if (data.npData.zoneFlag) {
            link = this.versionUlr.npCardAddZone
            hosCodeType = 1
          } else {
            link = this.versionUlr.npCardAdd
          }
          query = data.npData.query
        }
      }
      // 孕产 科室门诊详情 知名专家更多医生跳转
      if(type==3){
        // 0艾嘉
        if(urlType==0){
          link = this.versionUlr.ijMoreDoctorYunChan
        }
        // 1健康城市
        if(urlType==1){
          return
        }
      }
      // 儿科 科室门诊详情 知名专家更多医生跳转
      if(type==4){
        // 0艾嘉
        if(urlType==0){
          link = this.versionUlr.ijMoreDoctorErKe
        }
        // 1健康城市
        if(urlType==1){
          return
        }
      }
      // 0艾嘉，1健康城市 ，2系统本身
      this.goOtherLink(urlType, link, query, hosCodeType)
    },
    // 跳转远程胎心
    toFetalHeartList() {
      let h5Fuc = function() {}
      let iosData = {
        "type": "jumpView",
        "visible": true,
        "param": {
          "url": "/fetalheart/FetalHeartList",
          "urlType": "view",
          "callBack": ""
        }
      }
      global.callAPPFunction(iosData, iosData, h5Fuc);
    },
    // 跳转
    goWindowUrl(url) {
      if (url) {
        window.location.href = url;
      }
    },
    // 有值
    valuable(data) {
      if (
        data === null ||
        data === "" ||
        data === undefined ||
        data === "undefined"
      ) {
        return false
      }
      else{
       return true
      }
    },
}
